import MarketingFooterLinks from "@sharedComponents/marketing-footer-links";

import { BYSTADIUM_HOSTNAME } from "@stadium/helpers/app-routes";

import catalogPageHeroSliceBgImg from "@assets/images/catalog/catalog-hero-bg.svg";

export const appendCatalogParamToUrl = (url) => {
  const route = url && new URL(url, BYSTADIUM_HOSTNAME);
  if (route) {
    route.searchParams.append("previewCatalog", true);
    return route.toString();
  }
  return "";
};

export const getCatalogHeroSliceContent = (buttonsList = []) => ({
  bgImg: catalogPageHeroSliceBgImg,
  buttonsList,
});

export const getPreviewCatalogModalDetail = (data) => ({
  productData: data,
  hideVariantSelection: false,
  hidePrice: false,
  showFooter: false,
  viewOnlyMode: true,
  renderCatalogModeFooterLinks: () => <MarketingFooterLinks />,
});
